import React, { useEffect, useState } from 'react'

import { Navigate, useNavigate } from 'react-router-dom'
import { UserAuth } from '../context/AuthContext'
import { Box, CircularProgress } from '@mui/material';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase.config';

const ProtectedRoute = ({ children }) => {
    const { user, logOut } = UserAuth();
    const [checkPartners, setCheckPartners] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        (async () => {
            if (user != null) {
                try {
                    const u1 = await getDoc(doc(db, "partners", user.uid));
                    if (!u1.exists()) {
                        logOut();
                        navigate('/login');
                    }
                    else {
                        setCheckPartners(true)
                    }

                } catch (error) {
                    console.log(error);
                }
            } else {
                navigate('/login')
            }
        })();
    }, [user]);

    if (!checkPartners) {
        // return <Navigate to='/login'/>
        return (
            <Box height={'100%'} width={'100%'} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <CircularProgress />
            </Box>
        );
    }
    return children

}

export default ProtectedRoute